import { render, staticRenderFns } from "./CustomerOld.vue?vue&type=template&id=19eccf04&"
import script from "./CustomerOld.vue?vue&type=script&lang=js&"
export * from "./CustomerOld.vue?vue&type=script&lang=js&"
import style0 from "./CustomerOld.vue?vue&type=style&index=0&id=19eccf04&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports